import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { useAccess } from '@smx-ui-permission/hook/use-access';
import { Button } from 'antd';
import { useLazyLoadQuery, useMutation } from 'react-relay';
import { MutationParameters, PayloadError } from 'relay-runtime';

import {
    DrawingSetStatusInput,
    DrawingSetVersionChangeStatusInput,
} from '../graphql/__generated__/drawingSetVersionChangeStatusMutation.graphql';
import { drawingSetVersionFragment$key } from '../graphql/__generated__/drawingSetVersionFragment.graphql';
import { drawingSetVersionChangeStatusMutation } from '../graphql/mutation/drawing-set-version-change-status';
import { storeDrawingsModel } from '../model/store-drawings-model';

interface ButtonPublishProps {
    drawingSetVersionId: string;
    setCurrentStatusDrawingSetVersion?: React.Dispatch<React.SetStateAction<DrawingSetStatusInput | null>>;
}

export const ButtonPublish: React.FC<ButtonPublishProps> = ({
    drawingSetVersionId,
    setCurrentStatusDrawingSetVersion,
}) => {
    const resultEntity = useLazyLoadQuery(
        storeDrawingsModel.drawingSetVersion.queryOne!,
        { id: drawingSetVersionId },
        { fetchPolicy: 'store-or-network' },
    );

    const accessPublish = useAccess(['drawing.all.create', 'drawing.all.manage']);
    const accessUnPublish = useAccess(['drawing.all.manage']);

    const drawingSetVersion = useFragmentFromStore<drawingSetVersionFragment$key>(
        (resultEntity as any).drawingSetVersion,
    );

    const [commitChangeStatus, isInFlightChangingStatus] = useMutation(drawingSetVersionChangeStatusMutation);

    const commit = (input: DrawingSetVersionChangeStatusInput): MutationParameters => {
        return {
            variables: {
                input: input,
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                } else {
                    setCurrentStatusDrawingSetVersion?.(input.status);
                    console.log('Change status of drawings set version successful', response);
                }
            },
            onError: (error: any) => {
                console.error('Mutation error:', error);
            },
        } as unknown as MutationParameters;
    };

    const onClick = async () => {
        const newStatus = (drawingSetVersion.status === 'PUBLISHED' ? 'DRAFT' : 'PUBLISHED') as DrawingSetStatusInput;
        const data = {
            drawingSetVersionId,
            status: newStatus,
        };

        commitChangeStatus(commit(data));
    };

    return (
        ((accessPublish && drawingSetVersion.status !== 'PUBLISHED') || accessUnPublish) && (
            <Button
                loading={isInFlightChangingStatus}
                onClick={onClick}
                variant={'outlined'}
                color={drawingSetVersion.status === 'PUBLISHED' ? 'default' : 'green'}
            >
                {drawingSetVersion.status === 'PUBLISHED' ? 'Unpublish' : 'Publish'}
            </Button>
        )
    );
};
